import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useToken } from '../../../providers/Token.provider';
import { useLayout } from '../../../providers/Layout.provider';

export type LocationStateProps = {
  FullName: string;
  CardNumber: string;
  ExpirationDate: string;
  CVV: string;
};

const { Box, Title, Label, Term, TextField, Button, Icon, ImageMap } = vp;

type FC = FunctionComponent;

const CreditCardConfirmContainer: FC = () => {
  const history = useHistory();
  const location = useLocation<LocationStateProps>();
  const { color, setLayoutInfo } = useLayout();
  const { token } = useToken();
  useEffect(() => {
    setLayoutInfo(
      vp.chooseColor<string | null | undefined>('#FFD147', token?.BrandingDetails?.Branding?.PrimaryColor),
      'moon',
      ImageMap.flyingTablet.src,
      80,
      20,
      0,
      true,
      false,
    );
  }, []);

  return (
    <Box flx="col" jc="center" ai="center">
      <Box maxwidth="465px" flx="col">
        <Box ai="center" jc="center" width="100%">
          <Title title="Review Information" size="lg" bold />
        </Box>
        <Box flx="col" width="100%">
          <Label label="Name on Card" required color="light-grey" />
          <TextField
            name="credit-card-confirmation-name"
            variant="background"
            placeholder={location.state.FullName}
            placeholderColor
            disabled
            bold
            onBlur={() => {}}
            onChange={() => {}}
          />
          <Label label="Card Number" required color="light-grey" />
          <TextField
            name="credit-card-confirmation-number"
            variant="background"
            placeholder={location.state.CardNumber}
            placeholderColor
            disabled
            bold
            elementRight={<Icon icon="lock2" color="primary-dark-transparent" size="sm" />}
            onBlur={() => {}}
            onChange={() => {}}
          />
          <Box gap="sm">
            <Box width="49%" flx="col">
              <Label label="Exp.Date" required color="light-grey" />
              <TextField
                name="credit-card-confirmation-exp-date"
                variant="background"
                placeholder={location.state.ExpirationDate}
                placeholderColor
                disabled
                bold
                onBlur={() => {}}
                onChange={() => {}}
              />
            </Box>
            <Box width="49%" flx="col">
              <Label label="Security Code(CVV)" required color="light-grey" />
              <TextField
                name="credit-card-confirmation-cvv"
                variant="background"
                placeholder={location.state.CVV}
                placeholderColor
                disabled
                bold
                elementRight={<Icon icon="lock2" color="primary-dark-transparent" size="sm" />}
                onBlur={() => {}}
                onChange={() => {}}
              />
            </Box>
          </Box>
          <Box mt="md" mb="lg" height="auto">
            <Term term="This is a secure page and your information will be encrypted. Payment method information will not be saved." />
          </Box>
        </Box>

        <Box width="100%" height="auto" mt="md">
          <Button
            id="credit-card-confirmation-btn"
            label="Add Credit Card"
            width="100%"
            textColor={vp.getContrastColor(color)}
            size="xlg"
            background={color}
            textSize={1}
            noShadow
            bold
            round
            onClick={() =>
              history.push('/thank-you', {
                paymentMethodType: 'credit',
                paymentMethod: location.state.CardNumber,
              })
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CreditCardConfirmContainer;
